import isArray from 'lodash/isArray';

/**
 * @name insertByIndex
 * @param {Array} array
 * @param {Object} obj
 * @param {Object} index
 * @description insert by index
 */
// eslint-disable-next-line import/prefer-default-export
export const insertByIndex = (array, obj, index) => {
  if (isArray(obj)) {
    // forms grouped array, must not rewrite, but to add each new item
    const args = [index, 0].concat(obj);
    // eslint-disable-next-line prefer-spread
    array.splice.apply(array, args);
    return;
  }
  if (index === -1) {
    array.push(obj);
    return;
  }
  if (index === 0 && obj.isShell) {
    array.push(obj);
    return;
  }
  array.splice(index, 0, obj);
};
